<div class="text-white py-16">
  @if (loaded()) {

  @if (notFound()) {
  <app-not-found-page></app-not-found-page>
  } @else {

  @if (parentPage(); as parent) {
  <div class="max-w-screen-2xl mx-auto px-8">
    <h1 class="text-4xl md:text-6xl font-bold pb-8 leading-tight">{{ parent.title }}</h1>
  </div>

  <div class="flex flex-col gap-6 max-w-screen-lg mx-auto px-8 w-full">
    @for (post of posts(); track post.slug) {
    <a [routerLink]="['/', section(), post.slug]"
       class="flex flex-col sm:flex-row gap-6 rounded-lg p-4 transition-colors hover:bg-white/5 group">
      @if (post.featured_image) {
      <div class="sm:w-48 sm:min-w-48 w-full">
        <img [src]="post.featured_image" [alt]="post.title"
             class="w-full sm:w-48 h-48 object-cover rounded-lg">
      </div>
      }
      <div class="flex flex-col gap-2 justify-center min-w-0">
        <h2 class="text-2xl font-bold group-hover:text-primary transition-colors">{{ post.title }}</h2>
        @if (post.published_at) {
        <p class="text-sm text-gray-400">{{ post.published_at | date:'d MMMM yyyy' }}</p>
        }
        @if (post.meta.description) {
        <p class="text-gray-300 line-clamp-2">{{ post.meta.description }}</p>
        }
        <span class="text-primary font-bold">Read more</span>
      </div>
    </a>
    } @empty {
    <p class="text-gray-400">No posts yet.</p>
    }

    @if (pagination(); as pagination) {
    @if (pagination.last_page > 1) {
    <nav class="flex flex-row items-center justify-center gap-2 pt-8">
      @if (pagination.has_previous) {
      <a [routerLink]="pageLink(pagination.current_page - 1)"
         class="px-3 py-2 rounded-lg bg-white/10 hover:bg-white/20 transition-colors">
        Previous
      </a>
      }

      @for (p of pages(); track p) {
      @if (p === pagination.current_page) {
      <a [routerLink]="pageLink(p)"
         class="px-3 py-2 rounded-lg bg-primary text-black font-bold">
        {{ p }}
      </a>
      } @else {
      <a [routerLink]="pageLink(p)"
         class="px-3 py-2 rounded-lg bg-white/10 hover:bg-white/20 transition-colors">
        {{ p }}
      </a>
      }
      }

      @if (pagination.has_next) {
      <a [routerLink]="pageLink(pagination.current_page + 1)"
         class="px-3 py-2 rounded-lg bg-white/10 hover:bg-white/20 transition-colors">
        Next
      </a>
      }
    </nav>
    }
    }
  </div>
  }

  } <!-- @else (notFound check) -->
  } <!-- @if(loaded()) -->
  @else {
  <div class="flex flex-row items-center justify-center">
    <app-spinner></app-spinner>
  </div>
  }
</div>
